export default __webpack_public_path__ + "static/media/Cloud.18d3cd59.png";